import Flickity from "flickity";

class CollectionsCarousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = self.elem.querySelector('[data-collections-carousel]');
        self.prevButton = self.elem.querySelector('[data-collections-carousel-prev]');
        self.nextButton = self.elem.querySelector('[data-collections-carousel-next]');
    }

    init() {
        let self = this;

        const flkty = new Flickity(self.carousel, {
            cellAlign: 'left',
            groupCells: true,
            prevNextButtons: false,
            wrapAround: true,
        });

        // Show prev/next buttons if we have more than one 'page' of cells
        let inactiveCells = self.elem.querySelectorAll('.flickity-cell:not([class*="is-selected"])');

        if (inactiveCells.length > 0) {
            self.prevButton.classList.add('is-active');
            self.nextButton.classList.add('is-active');
        }

        // Handle prev button clicks
        self.prevButton.addEventListener('click', evt => {
            flkty.previous(true);
        });

        // Handle next button clicks
        self.nextButton.addEventListener('click', evt => {
            flkty.next(true);
        });
    }
}

export default CollectionsCarousel;
